import {
  BreadcrumbItem,
  BreadcrumbLabel,
  BreadcrumbList,
  BreadcrumbSeparator,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsHeader
} from '@criteria-labs/react'
import { type Service } from '@criteria-labs/docs-kit'
import { InspectorArticle, InspectorHeader } from '../article'
import { useParams, useRouter } from '../router'
import { EndpointInputs } from './EndpointInputs'
import { EndpointOverview } from './EndpointOverview'

export function EndpointDetail({ service }: { service: Service }) {
  const { push } = useRouter()

  const { endpoint_path, endpoint_method } = useParams()
  if (endpoint_path === undefined || endpoint_method === undefined) {
    return null
  }

  const endpoint = service.allEndpoints.find(
    (endpoint) => endpoint.path === endpoint_path && endpoint.method === endpoint_method
  )
  if (!endpoint) {
    return null
  }

  return (
    <InspectorArticle>
      <Tabs>
        <InspectorHeader className="space-y-3">
          <BreadcrumbList className="min-h-10">
            <BreadcrumbItem onClick={() => push('/')}>
              <BreadcrumbLabel>API</BreadcrumbLabel>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLabel>
                {endpoint.method.toUpperCase()}&nbsp;{endpoint.path}
              </BreadcrumbLabel>
            </BreadcrumbItem>
          </BreadcrumbList>
          <TabsHeader className="flex items-baseline gap-x-6">
            <Heading>Endpoint</Heading>
            <TabList>
              <Tab>Overview</Tab>
              {/* <Tab>Inputs</Tab> */}
              {/*              <Tab>Request Body</Tab>
              <Tab>Responses</Tab>
              <Tab>Authentication</Tab>
              <Tab>Examples</Tab>
              <Tab>Callbacks</Tab> */}
            </TabList>
          </TabsHeader>
        </InspectorHeader>
        <TabPanels>
          <TabPanel className="space-y-6">
            <EndpointOverview endpoint={endpoint} />
          </TabPanel>
          {/* <TabPanel className="space-y-6">
            <EndpointInputs endpoint={endpoint} />
          </TabPanel> */}
        </TabPanels>
      </Tabs>
    </InspectorArticle>
  )
}
